<template>
	<Icon v-bind="$props">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
			<path
				class="light"
				d="M432 256C432 264.8 424.8 272 416 272H32c-8.844 0-16-7.15-16-15.99C16 247.2 23.16 240 32 240h384C424.8 240 432 247.2 432 256z"
			/>
			<path
				class="regular"
				d="M432 256C432 269.3 421.3 280 408 280h-368c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h368C421.3 232 432 242.8 432 256z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'MinusIcon',
	components: { Icon },
	props,
}
</script>
